import { APIClient } from "api/api_helper";
import { SESSION_API } from "api/url_helper";
import { CurrentUser, GetUserData } from "common/service/CommonService";

const api = new APIClient();

export const SampleCollectionTimeApiService = {
  selectAllData: (payload_data: any) => {
    const payload = {
      studyid: payload_data?.studyid,
      searchtext: payload_data?.searchtext || "",
      period_number: payload_data?.period_number,
      timepoint_number: payload_data?.timepoint_number,
      filterstatus: payload_data?.filterstatus || "ALL",
    };
    return api.create(SESSION_API.SAMPLE_COLLECTION_TIME_API + "SelectAll", payload);
  },
  updateData: (payload_data: any) => {
    const user = GetUserData() as CurrentUser;
    const payload = {
      vaccutainerbarcode: payload_data.vaccutainerbarcode,
      samplecollectiontime: payload_data.samplecollectiontime,
      updatedby: user?.userid || payload_data.updatedby,
      updatereason: payload_data.updatereason || "Sample collection recorded",
    };
    return api.create(SESSION_API.SAMPLE_COLLECTION_TIME_API + "Update", payload);
  },
};
